import { render, staticRenderFns } from "./AddressCheckResults.vue?vue&type=template&id=2e21134c&scoped=true&"
import script from "./AddressCheckResults.vue?vue&type=script&lang=js&"
export * from "./AddressCheckResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e21134c",
  null
  
)

export default component.exports